/**
 * Browser tab title: "{page} | Halalin"
 * Match most specific path first (prefix order matters).
 */
const ROUTE_TITLE_RULES = [
  [/^\/ta\/kpi\/?$/, 'TA — KPI'],
  [/^\/ta\/attendance\/?$/, 'TA — Kehadiran'],
  [/^\/ta\/my-tasks\/?$/, 'TA — Tugas harian saya'],
  [/^\/ta\/tasks\/?$/, 'TA — Master tugas'],
  [/^\/ta\/schedule\/?$/, 'Jadwal TA'],
  [/^\/ta\/client-assignments\/?$/, 'TA — Penugasan Client'],
  [/^\/ta\/clients\/[^/]+\/?$/, 'TA — Dokumen client'],
  [/^\/ta\/clients\/?$/, 'TA — Checklist Client'],
  [/^\/ta\/documents\/upload\/?$/, 'TA — Upload dokumen client'],
  [/^\/ta\/documents\/?$/, 'Dokumen (Tenaga Ahli)'],
  [/^\/ta\/?$/, 'Tenaga Ahli — Ringkasan'],
  [/^\/superadmin\/activity\/?$/, 'Log aktivitas'],
  [/^\/superadmin\/auditor-assignments\/?$/, 'Penugasan auditor'],
  [/^\/superadmin\/ta-assignments\/?$/, 'Penugasan TA'],
  [/^\/superadmin\/ta-directory\/?$/, 'Daftar TA'],
  [/^\/superadmin\/clients\/[^/]+\/?$/, 'Detail Client'],
  [/^\/superadmin\/clients\/?$/, 'Manajemen Client'],
  [/^\/superadmin\/users\/[^/]+\/pemohon-settings\/company\/produk\/?$/, 'Profil pemohon — Produk'],
  [/^\/superadmin\/users\/[^/]+\/pemohon-settings\/company\/usaha\/?$/, 'Profil pemohon — Identitas usaha'],
  [/^\/superadmin\/users\/[^/]+\/pemohon-settings\/company\/pelaku\/?$/, 'Profil pemohon — Pelaku usaha'],
  [/^\/superadmin\/users\/[^/]+\/pemohon-settings\/business\/?$/, 'Profil pemohon — Usaha & PIC'],
  [/^\/superadmin\/users\/[^/]+\/pemohon-settings\/client\/?$/, 'Profil pemohon — Client'],
  [/^\/superadmin\/users\/[^/]+\/pemohon-settings\/?$/, 'Profil pemohon'],
  [/^\/superadmin\/users\/[^/]+\/?$/, 'Detail pengguna'],
  [/^\/superadmin\/users\/?$/, 'Manajemen Pengguna'],
  [/^\/superadmin\/payments\/?$/, 'Pembayaran'],
  [/^\/superadmin\/sales\/?$/, 'Penjualan & akuntansi'],
  [/^\/superadmin\/settings\/?$/, 'Pengaturan'],
  [/^\/payment\/?$/, 'Pembayaran'],
  [/^\/onboarding\/?$/, 'Registrasi & pembayaran'],
  [/^\/superadmin\/?$/, 'Superadmin'],
  [/^\/pre-assessment\/slhs/i, 'Pre-Assessment SLHS'],
  [/^\/pre-assessment\/haccp/i, 'Pre-Assessment HACCP'],
  [/^\/pre-assessment\/halal/i, 'Pre-Assessment Halal'],
  [/^\/pre-assessment/, 'Pre-Assessment'],
  [/^\/gap-assessment/, 'Gap Assessment'],
  [/^\/audit-external/, 'Audit Eksternal'],
  [/^\/documents\/?$/, 'Dokumen'],
  [/^\/settings\/profile\/?$/, 'Pengaturan — Profil'],
  [/^\/settings\/business\/?$/, 'Pengaturan — Usaha & PIC'],
  [/^\/settings\/company\/pelaku\/?$/, 'Pengaturan — Pelaku usaha'],
  [/^\/settings\/company\/usaha\/?$/, 'Pengaturan — Identitas usaha'],
  [/^\/settings\/company\/produk\/?$/, 'Pengaturan — Produk & produksi'],
  [/^\/settings\/client\/?$/, 'Pengaturan — Client'],
  [/^\/settings\/security\/?$/, 'Pengaturan — Keamanan'],
  [/^\/settings\/?$/, 'Pengaturan'],
  [/^\/verify\/certificate\/[^/]+\/?$/, 'Verifikasi Sertifikat'],
  [/^\/certificate\/?$/, 'Sertifikat'],
  [/^\/dashboard\/halal\/?$/, 'Halal (NIB Kecil)'],
  [/^\/dashboard\/slhs\/?$/, 'SLHS'],
  [/^\/dashboard\/haccp\/?$/, 'HACCP'],
  [/^\/dashboard\/?$/, 'Paket'],
  [/^\/register\/?$/, 'Daftar'],
  [/^\/forgot-password\/?$/, 'Lupa kata sandi'],
  [/^\/reset-password\/?$/, 'Atur ulang kata sandi'],
  [/^\/login\/?$/, 'Masuk'],
];

const SUFFIX = 'Halalin';

/**
 * @param {string} pathname
 * @returns {string} full document title
 */
export function formatDocumentTitle(pathname) {
  const path = pathname || '/';
  for (const [pattern, label] of ROUTE_TITLE_RULES) {
    if (pattern.test(path)) {
      return `${label} | ${SUFFIX}`;
    }
  }
  return SUFFIX;
}
